export interface ProgramsDraftSchool {
  id: string;
  name: string;
  fileName: string;
  programs: Array<{
    ProgramName: string;
    ProgramCategory: string;
    ProgramSchoolName: string;
    ProgramCode?: string;
    ProgramDegree?: string;
    ProgramDescription?: string;
    ProgramDomesticTuition?: string;
    ProgramInternationalTuition?: string;
    ProgramPrerequisites?: string;
    ProgramLanguage?: string;
    ProgramProvinceState?: string;
    ProgramURL?: string;
    ProgramAdditionalRequirements?: string;
    ProgramAdmissionsMinimum?: string;
    ProgramExperientialLearning?: string;
    ProgramLastUpdated?: string;
    ProgramLastDeleted?: string;
  }>;
}

export class ProgramsDraftService {
  // List of Canadian programs draft schools
  private static readonly CANADIAN_PROGRAMS_DRAFT_SCHOOLS: string[] = [
    // All Canadian programs have been processed and moved to programsApprovedAndAdded
  ];

  // List of US programs draft schools
  private static readonly US_PROGRAMS_DRAFT_SCHOOLS: string[] = [
    // Add US programs draft files here when available
  ];

  // Get Canadian programs draft schools
  static async getCanadianProgramsDraftSchools(): Promise<ProgramsDraftSchool[]> {
    const programsDraftSchools: ProgramsDraftSchool[] = [];

    for (const fileName of this.CANADIAN_PROGRAMS_DRAFT_SCHOOLS) {
      try {
        const schoolName = fileName
          .replace('-programs.json', '')
          .split('-')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ');

        // Load programs data from JSON file
        let programsData: any[] = [];
        
        try {
          // Import the JSON data dynamically from public directory
          const response = await fetch(`/${fileName}`);
          if (response.ok) {
            programsData = await response.json();
          }
        } catch (fetchError) {
          console.warn(`Could not load ${fileName}, using empty array:`, fetchError);
        }

        programsDraftSchools.push({
          id: fileName.replace('.json', ''),
          name: schoolName,
          fileName: fileName,
          programs: programsData
        });
      } catch (error) {
        console.error(`Error processing ${fileName}:`, error);
      }
    }

    return programsDraftSchools;
  }

  // Get US programs draft schools
  static async getUSProgramsDraftSchools(): Promise<ProgramsDraftSchool[]> {
    const programsDraftSchools: ProgramsDraftSchool[] = [];

    for (const fileName of this.US_PROGRAMS_DRAFT_SCHOOLS) {
      try {
        const schoolName = fileName
          .replace('-programs.json', '')
          .split('-')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ');

        // Add US programs data here when available
        const programsData: any[] = [];

        programsDraftSchools.push({
          id: fileName.replace('.json', ''),
          name: schoolName,
          fileName: fileName,
          programs: programsData
        });
      } catch (error) {
        console.error(`Error processing ${fileName}:`, error);
      }
    }

    return programsDraftSchools;
  }

  // Get programs draft schools based on country
  static async getProgramsDraftSchools(country: 'Canada' | 'US'): Promise<ProgramsDraftSchool[]> {
    if (country === 'Canada') {
      return this.getCanadianProgramsDraftSchools();
    } else {
      return this.getUSProgramsDraftSchools();
    }
  }
}
